// extracted by mini-css-extract-plugin
export default {"link":"cR-z","disabled":"dR-z"};